import { getSession } from "../shared/api";
import {
  buildShellSearch,
  parseProductId,
  resolveProductRoute,
  type ProductId,
  type ProductRoute
} from "./productRouting";

const PRODUCT_STORAGE_KEY = "clex_addin_product";

/** URL tuyệt đối tới `remoteEntry.js` của add-in ENT (được phép khác origin). */
export const entRemoteEntryUrl = readEntRemoteEntryUrl();

/** Chỉ bật chọn sản phẩm khi đã cấu hình remote ENT. */
export function isProductSwitchEnabled(): boolean {
  return Boolean(entRemoteEntryUrl);
}

export function readStoredProduct(): ProductId | null {
  try {
    return parseProductId(localStorage.getItem(PRODUCT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function rememberProduct(product: ProductId): void {
  try {
    localStorage.setItem(PRODUCT_STORAGE_KEY, product);
  } catch {
    // ignore — private mode / quota
  }
}

export function resolveCurrentProductRoute(): ProductRoute {
  return resolveProductRoute({
    search: window.location.search,
    storedProduct: readStoredProduct(),
    hasComSession: getSession() !== null,
    entEnabled: isProductSwitchEnabled()
  });
}

/**
 * Chọn sản phẩm: ghi nhớ rồi tải lại shell với `?product=` để vào thẳng màn đăng nhập
 * của sản phẩm đó. Tải lại để CSS/JS của sản phẩm trước không còn trên trang.
 */
export function selectProduct(product: ProductId): void {
  rememberProduct(product);
  window.location.replace(shellUrl({ product }));
}

export function goToProductPicker(): void {
  window.location.replace(productPickerUrl());
}

/** URL màn chọn sản phẩm; giữ query Office (vd. `_host_Info`). */
export function productPickerUrl(): string {
  return shellUrl("picker");
}

function shellUrl(target: Parameters<typeof buildShellSearch>[1]): string {
  return `${window.location.pathname}${buildShellSearch(window.location.search, target)}`;
}

function readEntRemoteEntryUrl(): string {
  const raw = import.meta.env.VITE_ENT_REMOTE_ENTRY;
  if (typeof raw !== "string" || !raw.trim()) {
    return "";
  }
  try {
    return new URL(raw.trim()).toString();
  } catch {
    console.warn("VITE_ENT_REMOTE_ENTRY phải là URL tuyệt đối tới remoteEntry.js; tắt chọn sản phẩm.");
    return "";
  }
}
